import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

import { ElMessage } from 'element-plus';
import accountMngImportStatusTw from '@/assets/img/accountMngImportStatus-zhtw.png';
import accountMngImportStatusEn from '@/assets/img/accountMngImportStatus-en.png';
import accountMngImportStatusCn from '@/assets/img/accountMngImportStatus-cn.png';

import accountMngExcel from '@/assets/img/accountManagementExcel.png';
import buUserSettingExcel from '@/assets/img/buUserExcel.png';

/**
 * 呼叫新增廠區
 * @param {*} i18n
 */
export function callHelpAddFactory(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#v-step-0',
        popover: {
          title: i18n.$t('System_As_2').addFactory,
          description: i18n.$t('System_As_2').CreateNoExistFactory,
          onNextClick: () => {
            if (store.state.system.factoryDialogVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.el-row.must',
        popover: {
          title: i18n.$t('System_As_2').addFactoryInterfaceSetting,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '.explain',
        popover: {
          title: i18n.$t('System_As_2').explainTitle,
          description: `${i18n.$t('System_As_2').notInput} "\\/[]!@#$%^&*()+ `,
        },
      },
      {
        element: '#v-step-3',
        popover: {
          title: i18n.$t('System_As_2').DBConnectTest,
          description: i18n.$t('System_As_2').DBConnectTestExplain,
        },
      },
      {
        element: '#v-step-4',
        popover: {
          title: i18n.$t('Button').confirm,
          description: i18n.$t('System_As_2').ConfirmExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫編輯廠區
 * @param {*} i18n
 */
export function callHelpEditFactory(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#editFactory',
        popover: {
          title: i18n.$t('System_As_2').editFactory,
          description: i18n.$t('System_As_2').EditExistFactory,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫刪除廠區
 * @param {*} i18n
 */
export function callHelpDeleteFactory(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#deleteFactory',
        popover: {
          title: i18n.$t('System_As_2').deleteFactory,
          description: i18n.$t('System_As_2').selectAndDeleteExistFactory,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫篩選廠區
 * @param {*} i18n
 */
export function callHelpFilterFactory(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#filterFactory',
        popover: {
          title: i18n.$t('System_As_2').filterFactory,
          description: i18n.$t('System_As_2').filterFactoryExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫新增季度線排程設定
 * @param {*} i18n
 */
export function callHelpCreateReviewSchedule(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#createReviewSchedule',
        popover: {
          title: i18n.$t('System_As_3').CreateReviewSchedule,
          description: i18n.$t('System_As_3').CreateNoExistReviewSchedule,
          onNextClick: () => {
            if (store.state.system.reviewScheduleDialogVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '#must',
        popover: {
          title: i18n.$t('System_As_3').CreateReviewScheduleUI,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '.el-row.nameMust',
        popover: {
          title: i18n.$t('As_3').name,
          description: `${i18n.$t('System_As_3').notInput} "\\/[]!@#$%^&*()+ `,
        },
      },
      {
        element: '.el-row.dateRangeMust',
        popover: {
          title: i18n.$t('System_As_3').startEndTime,
          description: i18n.$t('System_As_3').startEndTimeExplain,
        },
      },
      {
        element: '#timeRangeMust',
        popover: {
          title: i18n.$t('System_As_3').setExecuteTime,
          description: i18n.$t('System_As_3').setExecuteTimeExplain,
        },
      },
      {
        element: '#timeRangeMust',
        popover: {
          title: i18n.$t('System_As_3').finalExplain,
          description: i18n.$t('System_As_3').finalExplainDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫編輯季度線排程設定
 * @param {*} i18n
 */
export function callHelpEditReviewSchedule(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#editReviewSchedule',
        popover: {
          title: i18n.$t('System_As_3').EditReviewSchedule,
          description: i18n.$t('System_As_3').EditExistReviewSchedule,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫刪除季度線排程設定
 * @param {*} i18n
 */
export function callHelpDeleteReviewSchedule(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#deleteReviewSchedule',
        popover: {
          title: i18n.$t('System_As_3').DeleteReviewSchedule,
          description: i18n.$t('System_As_3').selectAndDeleteExistReviewSchedule,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫篩選季度線排程設定
 * @param {*} i18n
 */
export function callHelpFilterReviewSchedule(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#filterReviewSchedule',
        popover: {
          title: i18n.$t('System_As_3').FilterReviewSchedule,
          description: i18n.$t('System_As_3').FilterReviewScheduleExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫下次執行排程
 * @param {*} i18n
 */
export function callHelpNextExecuteSchedule(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#nextExecuteSchedule',
        popover: {
          title: i18n.$t('System_As_3').nextExecuteSchedule,
          description: i18n.$t('System_As_3').nextExecuteScheduleExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫系統金鑰
 * @param {*} i18n
 */
export function callHelpSystemKey(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#ImportantExplain',
        popover: {
          title: i18n.$t('System').ImportantExplain,
          description: i18n.$t('System').registerCodeExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫新增基礎權限設定
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpCreateBasicAuthoritySetting(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.button-add',
        popover: {
          title: i18n.$t('System_Bs_1').CreateBasicAuthoritySetting,
          description: i18n.$t('System_Bs_1').CreateBasicAuthoritySettingExplain,
          onNextClick: () => {
            if (store.state.system.basicAuthoritySettingVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '#must',
        popover: {
          title: i18n.$t('System_Bs_1').CreateBasicAuthoritySetting,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫編輯基礎權限設定
 * @param {*} i18n
 */
export function callHelpEditBasicAuthoritySetting(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.el-button.listEditBtn',
        popover: {
          title: i18n.$t('System_Bs_1').EditBasicAuthoritySetting,
          description: i18n.$t('System_Bs_1').EditBasicAuthoritySettingDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫編輯權限(許可權)
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpAuthorityUpdate(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#authorityUpdate',
        popover: {
          title: i18n.$t('System_Bs_1').Authority,
          description: i18n.$t('System_Bs_1').AuthorityDescription,
          onNextClick: () => {
            if (store.state.system.authorityUpdateVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickPermissionButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.createaccess-group',
        popover: {
          title: i18n.$t('System_Bs_1').Authority,
          description: i18n.$t('System_Bs_1').AuthorityExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫刪除基礎權限設定
 * @param {*} i18n
 */
export function callHelpDeleteBasicAuthoritySetting(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.el-button.listDeleteBtn',
        popover: {
          title: i18n.$t('System_Bs_1').DeleteBasicAuthoritySetting,
          description: i18n.$t('System_Bs_1').DeleteBasicAuthoritySettingDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫篩選基礎權限設定
 * @param {*} i18n
 */
export function callHelpFilterBasicAuthoritySetting(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#searchRow',
        popover: {
          title: i18n.$t('System_Bs_1').FilterBasicAuthoritySetting,
          description: i18n.$t('System_Bs_1').FilterBasicAuthoritySettingDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫新增廠區使用者
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpCreateBuUser(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.button-add',
        popover: {
          title: i18n.$t('System_Bs_2').CreateBuUser,
          description: i18n.$t('System_Bs_2').CreateBuUserExplain,
          onNextClick: () => {
            if (store.state.system.buUserSettingsDialogVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.sysBuUserAddMust',
        popover: {
          title: i18n.$t('System_Bs_2').CreateBuUser,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '.roleExplain',
        popover: {
          title: i18n.$t('Label').role,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('System_Bs_2').roleExplain}</p>`,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫編輯廠區使用者
 * @param {*} i18n
 */
export function callHelpEditBuUser(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.el-button.listEditBtn',
        popover: {
          title: i18n.$t('System_Bs_2').EditBuUser,
          description: i18n.$t('System_Bs_2').EditBuUserExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫刪除廠區使用者
 * @param {*} i18n
 */
export function callHelpDeleteBuUser(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.el-button.listDeleteBtn',
        popover: {
          title: i18n.$t('System_Bs_2').DeleteBuUser,
          description: i18n.$t('System_Bs_2').DeleteBuUserExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫篩選廠區使用者
 * @param {*} i18n
 */
export function callHelpFilterBuUser(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#searchRow',
        popover: {
          title: i18n.$t('System_Bs_2').FilterBuUser,
          description: i18n.$t('System_Bs_2').FilterBuUserExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫新增帳號
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpCreateAccount(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.createBtn',
        popover: {
          title: i18n.$t('System_Bs_3').CreateAccount,
          description: i18n.$t('System_Bs_3').CreateAccountExplain,
          onNextClick: () => {
            if (store.state.system.accountManagementDialogVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.el-row.must',
        popover: {
          title: i18n.$t('System_Bs_3').CreateAccount,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('System_Bs_3').accountEmployeeId}</p>`,
        },
      },
      {
        element: '.superuser',
        popover: {
          title: i18n.$t('System_Bs_3').ManagePermission,
          description: i18n.$t('System_Bs_3').ManagePermissionExplain,
        },
      },
      {
        element: '.enginner',
        popover: {
          title: i18n.$t('System_Bs_3').EnginnerMode,
          description: i18n.$t('System_Bs_3').EnginnerModeExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫編輯帳號
 * @param {*} i18n
 */
export function callHelpEditAccount(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.el-button.listEditBtn',
        popover: {
          title: i18n.$t('System_Bs_3').EditAccount,
          description: i18n.$t('System_Bs_3').EditAccountExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫修改密碼
 * @param {*} i18n
 */
export function callHelpModifyPassword(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.el-button.listPasswordBtn',
        popover: {
          title: i18n.$t('System_Bs_3').ModifyPassword,
          description: i18n.$t('System_Bs_3').ModifyPasswordExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫刪除帳號
 * @param {*} i18n
 */
export function callHelpDeleteAccount(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.el-button.listDeleteBtn',
        popover: {
          title: i18n.$t('System_Bs_3').DeleteAccount,
          description: i18n.$t('System_Bs_3').DeleteAccountExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫篩選帳號
 * @param {*} i18n
 */
export function callHelpFilterAccount(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#searchRow',
        popover: {
          title: i18n.$t('System_Bs_3').FilterAccount,
          description: i18n.$t('System_Bs_3').FilterAccountExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫同步帳號
 * @param {*} i18n
 */
export function callHelpSyncAccount(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.syncBtn',
        popover: {
          title: i18n.$t('System_Bs_3').SyncAccount,
          description: i18n.$t('System_Bs_3').SyncAccountExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫資料匯入
 * @param {*} i18n
 */
export function callHelpDataImport(i18n, store) {
  let imgSource = null;
  switch (store.state.lang) {
    case 'zhtw':
      imgSource = accountMngImportStatusTw;
      break;

    case 'en':
      imgSource = accountMngImportStatusEn;
      break;

    case 'cn':
      imgSource = accountMngImportStatusCn;
      break;

    default:
      imgSource = accountMngImportStatusTw;
      break;
  }

  const htmlContext = `
  <img src='${imgSource}' width="850"></img>
  <p>${i18n.$t('System_Bs_4').ImportStatusExplain}</p>`;

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.el-button.btn-confirm',
        popover: {
          title: i18n.$t('System_Bs_4').TemplateDownload,
          description: i18n.$t('System_Bs_4').TemplateDownloadExplain,
        },
      },
      {
        element: '#importBtn',
        popover: {
          title: i18n.$t('System_Bs_4').DataImport,
          description: i18n.$t('System_Bs_4').DataImportExplain,
        },
      },

      {
        element: '#icon',
        popover: {
          title: i18n.$t('System_Bs_4').CurrentStatus,
          description: i18n.$t('System_Bs_4').CurrentStatusExplain,
        },
      },

      {
        popover: {
          title: i18n.$t('System_Bs_4').DataImport,
          description: htmlContext,
          popoverClass: 'classImportStatus',
        },
      },

      {
        element: '.refreshBtn',
        popover: {
          title: i18n.$t('System_Bs_4').Refresh,
          description: i18n.$t('System_Bs_4').RefreshExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫帳號管理範本
 * @param {*} i18n
 */
export function callHelpAccountManagementTemplate(i18n) {
  const driverObj = driver({
    popoverClass: 'classImportStatus',
  });
  const htmlContext = `
  <img src='${accountMngExcel}' width="850"></img>
  <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
  <p>NAME:${i18n.$t('System_Bs_4').accountExcelNAME}</p>
  <p>EMP_CODE:${i18n.$t('System_Bs_4').accountExcelEMP_CODE}</p>
  <p>ACCOUNT:${i18n.$t('System_Bs_4').accountExcelACCOUNT}</p>
  <p>PASSWORD:${i18n.$t('System_Bs_4').accountExcelPASSWORD}</p>
  <p>MOBILE:${i18n.$t('System_Bs_4').accountExcelMOBILE}</p>
  <p>EMAIL:${i18n.$t('System_Bs_4').accountExcelEMAIL}</p>
  <p>ENABLE:${i18n.$t('System_Bs_4').accountExcelENABLE}</p>`;

  driverObj.highlight({
    popover: {
      title: i18n.$t('System_Bs_4').accountManagementTemplate,
      description: htmlContext,
    },
  });
}

/**
 * 呼叫廠區使用者設定範本
 * @param {*} i18n
 */
export function callHelpBuUserSettingTemplate(i18n) {
  const driverObj = driver({
    popoverClass: 'classImportStatus',
  });
  const htmlContext = `
  <img src='${buUserSettingExcel}' width="390"></img>
  <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
  <p>BU_CODE:${i18n.$t('System_Bs_4').buUserSettingExcelBU_CODE}</p>
  <p>EMP_CODE:${i18n.$t('System_Bs_4').buUserSettingExcelEMP_CODE}</p>
  <p>ROLE_NAME:${i18n.$t('System_Bs_4').buUserSettingExcelROLE_NAME}</p>`;

  driverObj.highlight({
    popover: {
      title: i18n.$t('System_Bs_4').buUserSettingTemplate,
      description: htmlContext,
    },
  });
}

/**
 * 呼叫Mail (SMTP)通知設定
 * @param {*} i18n
 */
export function callHelpMailNotify(i18n) {
  const htmlContext = `
  <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
  <p>${i18n.$t('System_Cs_2').mailNotifyExplain}</p>`;

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.btn-cancel',
        popover: {
          title: i18n.$t('System_Cs_2').clear,
          description: i18n.$t('System_Cs_2').clearExplain,
        },
      },
      {
        element: '#testBtn',
        popover: {
          title: i18n.$t('System_Cs_2').test,
          description: i18n.$t('System_Cs_2').testExplain,
        },
      },
      {
        element: '#confirmBtn',
        popover: {
          title: i18n.$t('System_Cs_2').confirm,
          description: i18n.$t('System_Cs_2').confirmExplain,
        },
      },
      {
        element: '.form-wrap',
        popover: {
          title: i18n.$t('System').ImportantExplain,
          description: htmlContext,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫weChat 通知設定
 * @param {*} i18n
 */
export function callHelpWeChatNotify(i18n) {
  const htmlContext = `
  <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
  <p>${i18n.$t('System_Cs_3').weChatNotifyExplain}</p>`;

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.btn-cancel',
        popover: {
          title: i18n.$t('System_Cs_3').clear,
          description: i18n.$t('System_Cs_3').clearExplain,
        },
      },
      {
        element: '#testBtn',
        popover: {
          title: i18n.$t('System_Cs_3').test,
          description: i18n.$t('System_Cs_3').testExplain,
        },
      },
      {
        element: '#confirmBtn',
        popover: {
          title: i18n.$t('System_Cs_3').confirm,
          description: i18n.$t('System_Cs_3').confirmExplain,
        },
      },
      {
        element: '.form-wrap',
        popover: {
          title: i18n.$t('System').ImportantExplain,
          description: htmlContext,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}
